import React from 'react';
import { SectionList, SectionListProps } from 'react-native';

const SectionListCustom = (props: SectionListProps<any, any>) => (
  <SectionList {...props} />
);

export default SectionListCustom;
